import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NavBar from "../components/navBar/NavBar";
import FooterComponent from "../components/footer/FooterComponent";
import { phases } from "../data/data";
import "../styles/courses.css";
import useIsMobile from "../components/isMobile/IsMobile";

const Courses = () => {
  const navigate = useNavigate();
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFadeIn(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const isMobile = useIsMobile(768);
  return (
    <div className="courses-page">
      <NavBar />

      <div
        className={`courses-header ${fadeIn ? "fade-in" : ""}`}
        style={{ padding: "0px 16px" }}
      >
        <h1 className="courses-title">Courses</h1>

        <p className="courses-subtitle">
          Structuring Your Online Jolly Phonics Journey:
        </p>

        <p className="courses-text">
          From Sounds to Storytelling. Our online platform is designed to guide
          young learners through the exciting world of phonics, building strong
          reading and writing foundations with the proven Jolly Phonics
          methodology. We understand that every child learns at their own pace,
          and our curriculum is thoughtfully segmented to ensure a rich,
          engaging, and age-appropriate learning experience.
        </p>

        <p className="courses-highlight">
          Here's how we've structured our Jolly Phonics content, from the very
          first sounds to confident reading, with approximate age guidelines and
          suggested durations:
        </p>
      </div>

      <div className="courses-phases">
        {isMobile ? (
          <>
            {phases.map((phase, index) => (
              <div
                key={phase.id}
                className={`phase-cardmobile ${index % 2 !== 0 ? "" : ""}`}
              >
                <div className="phase-image">
                  <img
                    src={phase.image}
                    alt={phase.title}
                    className="phase-img"
                  />
                </div>
                <div className="phase-text">
                  <h2 className="phase-title">{phase.title}</h2>
                  <p className="phase-content">{phase.content}</p>
                  <div
                    className="phase-button"
                    onClick={() => {
                      navigate(`/course/${phase.id}`);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    Click Here!
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <>
            {phases.map((phase, index) => (
              <div
                key={phase.id}
                className={`phase-card ${index % 2 !== 0 ? "reverse" : ""}`}
              >
                <div className="phase-image">
                  <img
                    src={phase.image}
                    alt={phase.title}
                    className="phase-img"
                  />
                </div>
                <div className="phase-text">
                  <h2 className="phase-title">{phase.title}</h2>
                  <p className="phase-content">{phase.content}</p>
                  <div
                    className="phase-button"
                    onClick={() => navigate(`/course/${phase.id}`)}
                  >
                    Click Here!
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      <FooterComponent />
    </div>
  );
};

export default Courses;
